import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    catalog: {},
    userCatalog: {},
    allowed: [],
    permissionSet: [],
    userPrivilegesData: [],
    prefix: "",
    type: "",
    sectionName: "",
    masterId: ""
};

const userPrivilegesSlice = createSlice({
    name: "userPrivileges",
    initialState,
    reducers: {
        setCatalog(state, action) {
            state.catalog = action.payload;
        },
        setDynamicAllowedCatalog(state, action) {
            state.userCatalog = action.payload;
        },
        setAllowedIds(state, action) {
            state.allowed = action.payload;
            state.permissionSet = action.payload;
        },
        setUserPrivilegesData(state, action) {
            state.userPrivilegesData = action.payload;
        },
        setPrifix: (state, action) => {
            state.prefix = action.payload;
        },
        setType: (state, action) => {
            state.type = action.payload;
        },
        setSectionName: (state, action) => {
            state.sectionName = action.payload;
        },
        removePrifix: (state) => {
            state.prefix = "";
        },
        setMasterId: (state, action) => {
            state.masterId = action.payload;
        },
        resetUserPrivileges(state) {
            state.catalog = {};
            state.userCatalog = {};
            state.allowed = [];
            state.permissionSet = [];
            state.userPrivilegesData = [];
            state.prefix = "";
            state.type = "";
            state.sectionName = "";
            state.masterId = "";
        },
    }
});

export const {
    setCatalog, setAllowedIds, setUserPrivilegesData, setDynamicAllowedCatalog, resetUserPrivileges,
    setMasterId,
    setPrifix, setType, setSectionName, removePrifix
} = userPrivilegesSlice.actions;
export default userPrivilegesSlice.reducer;